let routes = [
  {
    path: '/house-importer',
    component: () => import('@/layouts/house-importer/HouseImporter.vue'),
    children: [
      {
        path: '',
        name: 'houseImporter_main',
        component: () => import('@/views/houses-importer/MainPage.vue'),
        meta: {
          rule: 'isHouseImporter'
        }
      },
      {
        path: 'import/:id/stage-:stage',
        name: 'houseImporter_import',
        component: () => import('@/views/houses-importer/ImportStagePage.vue'),
        meta: {
          rule: 'isHouseImporter'
        }
      },
      {
        path: 'import-not-found',
        name: 'houseImporter404',
        component: () => import('@/views/pages/ObjectNotFound.vue'),
        meta: {
          rule: 'isHouseImporter'
        }
      },
    ],
  },
];

export default routes;
